import { get } from 'lodash'

// - const loadingPageHost = get(process.env, 'LOADING_PAGE_HOST')

const types = {
  clinic: 'Clínica Médica',
  office: 'Consultório médico',
  'emergency_room': 'Emergência',
  laboratory: 'Labotarório',
  others: 'Outros'
}

/** tratando se for develop */
const getHost = () => {
  if (get(process.env, 'NODE_ENV') === 'development') {
    return window.location.host.replace(':8080', '')
  } else {
    return window.location.host
  }
}

const parseType = (type) => {
  return get(types, type, 'Outros')
}

const prepareShow = professionalProfilePublic => {
  professionalProfilePublic.hide = false
  professionalProfilePublic.company_type = parseType(professionalProfilePublic.agenda.address.company)
  return professionalProfilePublic
}

export default {
  async checkDomainOperator () {
    const host = {
      domain: getHost()
    }
    this.noProfilePublic = false
    await this.$http.post('v1/scheduling/see/operator/domain', host)
      .then(({data}) => {
        /** Removendo valores anteriores */
        const operatorCovenantSession = localStorage.getItem('operador-covenant')
        if (operatorCovenantSession !== null) {
          localStorage.removeItem('operador-covenant')
        }

        /** setando dominio da operadora */
        localStorage.setItem('operador-domain', getHost())

        /** se tem resultado  */
        if (data.length >= 1) {
          localStorage.setItem('operador-covenant', data[0].name)
        }
        this.getByCompany()
        this.getCompanyProfessionalSchedules()
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  /** Retornand estatistica do estabelecimento */
  async getByCompany () {
    this.loading = true
    await this.$http.get('/v1/scheduling/see/company/cnpj/' + this.cnpj)
      .then(({data}) => {
        this.profilePublic = data
        this.operatorCovenant = localStorage.getItem('operador-covenant')
        // Verificando profilePublic contem dados, se nao tiver perfil ainda entao mostra msg
        if (typeof this.profilePublic === 'object') {
          if (this.profilePublic.length <= 0) {
            // visualizando msg professional nao tem perfila ainda
            this.noProfilePublic = true
            this.loading = false
            this.loadingTwo = false
          }
        }
      })
      .catch((error) => {
        this.afterFailure(error)
      })
  },
  async getCompanyProfessionalSchedules () {
    this.$http.get('/v1/scheduling/see/cnpj/' + this.cnpj + '?pagination=false')
      .then(({data}) => {
        this.companyProfileProfessionals = data
        /** Total agendas company */
        this.totalAgendas = data.length

        /** Total de agendamento para company */
        this.totalAgendaSchedules = this.companyProfileProfessionals.reduce((acc, item) => {
          return acc + item.total_agendas
        }, 0)

        /** Array para retorno do novo array  */
        let reduced = []

        /** Retornando quantidade de professionais pelo crm  */
        data.forEach((item) => {
          var duplicated = reduced.findIndex(ri => {
            return item.document === ri.document
          }) > -1

          if (!duplicated) {
            reduced.push(item)
          }
        })
        this.totalProfessional = reduced.length
        this.operatorCovenant = localStorage.getItem('operador-covenant')
        // removendo loading de processamento
        this.loading = false
      })
      .catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  },
  openExternalLink: function (url) {
    if (url === 'null') {
      return
    }
    window.open(url, '_blank')
  },
  prepareShow,
  typeClinic: function (type) {
    const clinicType = parseType(type)
    return clinicType
  },
  priceReal (price) {
    const real = price.split('.')
    return real[0]
  },
  priceCents (price) {
    const real = price.split('.')
    return real[1]
  },
  isAvatar (avatar) {
    const a = avatar.split('/')
    return a[5]
  },
  setShow: function (item) {
    if (item.hide === false) {
      this.$set(item, 'hide', true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company/gadget/resources/methods.js